import { LendiMemberType } from '../../../../twilio';
import parsePhoneNumber from 'libphonenumber-js';
export var GUEST_IDENTITY = 'guest';
export var BOT_IDENTITY = 'bot';
export var TIMEOUT_VALUE = 15; // in sec
export var LENDI_BOT_MEMBER = {
    identity: BOT_IDENTITY,
    type: LendiMemberType.BOT,
    isOnline: false,
    isTyping: false,
    firstName: 'Lendi',
    lastName: 'Singh',
    lastConsumedMessageIndex: 0,
};
export var smartChatMembers = [
    LENDI_BOT_MEMBER,
    {
        identity: 'guest',
        type: LendiMemberType.CUSTOMER,
        isOnline: false,
        isTyping: false,
        firstName: 'Guest',
        lastName: 'Singh',
        lastConsumedMessageIndex: 0,
    },
];
export var chatMessage = function (msg) { return [
    {
        index: 1,
        text: msg,
        authorIdentity: BOT_IDENTITY,
        author: LENDI_BOT_MEMBER,
        dateCreated: new Date(),
        currentMembers: [],
    },
]; };
export var sleep = function (ms) { return new Promise(function (resolve) { return setTimeout(resolve, ms); }); };
export var createBotMessage = function (text, index) {
    return {
        index: index,
        text: text,
        authorIdentity: BOT_IDENTITY,
        author: LENDI_BOT_MEMBER,
        dateCreated: new Date(),
        currentMembers: [],
    };
};
export var createGuestMessage = function (text, index) {
    return {
        index: index,
        text: text,
        authorIdentity: GUEST_IDENTITY,
        author: LENDI_BOT_MEMBER,
        dateCreated: new Date(),
        currentMembers: [],
    };
};
export var scrollToBottom = function (target) {
    if (target && target.scrollIntoView) {
        target.scrollIntoView({ block: 'end', behavior: 'auto' });
    }
};
export var trim = function (input) {
    return input
        .replace(/\r?\n|\r/g, ' ')
        .split(' ')
        .join('');
};
export var formatPhone = function (phoneNumber) {
    var chunks = phoneNumber.match(/.{1,3}/g);
    return chunks.join(' ');
};
export var validateAndFormatPhoneNumber = function (input) {
    var formattedMobileNumber = parsePhoneNumber(input, 'AU');
    if (formattedMobileNumber) {
        if (!formattedMobileNumber.isValid() || formattedMobileNumber.getType() !== 'MOBILE') {
            return null;
        }
        else {
            return formattedMobileNumber.number.toString();
        }
    }
    return null;
};
//# sourceMappingURL=index.js.map